const modal = document.getElementById('contact-modal');
const openBtn = document.getElementById('open-modal');
const closeBtn = document.getElementById('close-modal');

if (modal && openBtn && closeBtn) {
    const toggleModal = () => {
        modal.classList.toggle('hidden');
        if (!modal.classList.contains('hidden')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    };

    openBtn.addEventListener('click', toggleModal);
    closeBtn.addEventListener('click', toggleModal);

    modal.addEventListener('click', (e) => {
        if (e.target === modal) toggleModal();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
            toggleModal();
        }
    });
}

const navLinks = [...document.querySelectorAll('.nav-link[href^="#"]')];
const getScrollOffset = () => {
    const fixedHeader = document.querySelector('header.sticky, header');
    const fixedNav = document.querySelector('.nav-scroll')?.closest('nav');
    const headerHeight = fixedHeader ? fixedHeader.offsetHeight : 0;
    const navHeight = fixedNav ? fixedNav.offsetHeight : 0;

    return headerHeight + navHeight + 24;
};

const setActiveLink = (activeId) => {
    navLinks.forEach((link) => {
        const targetId = link.getAttribute('href')?.slice(1);
        link.classList.toggle('is-active', targetId === activeId);
    });
};

const updateActiveNavLink = () => {
    if (!navLinks.length) return;

    const offset = getScrollOffset();
    const targets = navLinks
        .map((link) => document.getElementById(link.getAttribute('href')?.slice(1)))
        .filter(Boolean);

    if (!targets.length) return;

    let activeId = targets[0].id;

    targets.forEach((target) => {
        if (window.scrollY + offset >= target.offsetTop) {
            activeId = target.id;
        }
    });

    setActiveLink(activeId);
};

if (navLinks.length) {
    navLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            const targetId = link.getAttribute('href')?.slice(1);
            const target = targetId ? document.getElementById(targetId) : null;

            if (!target) return;

            event.preventDefault();

            window.scrollTo({
                top: target.offsetTop - getScrollOffset(),
                behavior: 'smooth',
            });

            setActiveLink(targetId);
        });
    });

    window.addEventListener('scroll', updateActiveNavLink, { passive: true });
    window.addEventListener('resize', updateActiveNavLink);
    updateActiveNavLink();
}
